export const SEARCH_LOADING_SIZE = 100;
